import { useState } from "react";
import { toast } from "sonner";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { api, apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Mail } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Please fill in all fields"); return; }
    setSending(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message || "Message sent");
      setForm({ name: "", email: "", message: "" });
    } catch (err) { toast.error(apiError(err)); }
    finally { setSending(false); }
  };

  return (
    <>
      <Seo title="Contact & Support" path="/contact" />
      <PageHeader eyebrow="Contact & support" title="We're here to help"
        subtitle="Questions about an order, a report, or a refund? Send us a message and our support team will reply." />
      <section className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-20">
        <div className="bg-white rounded-2xl border border-border p-8">
          <form onSubmit={submit} className="space-y-5" data-testid="contact-form">
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Your name</label>
              <Input data-testid="contact-name" value={form.name} onChange={set("name")} placeholder="Full name" aria-label="Your name" />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Email</label>
              <Input data-testid="contact-email" type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" aria-label="Email" />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700 mb-1.5 block">Message</label>
              <Textarea data-testid="contact-message" rows={5} value={form.message} onChange={set("message")} placeholder="How can we help?" aria-label="Message" />
            </div>
            <button type="submit" disabled={sending} data-testid="contact-submit" className="btn-primary w-full">
              <Mail className="w-4 h-4" /> {sending ? "Sending…" : "Send message"}
            </button>
          </form>
        </div>
        <p className="text-center text-sm text-slate-500 mt-6">
          Prefer email? Reach us anytime and include your Order ID (AET-…) if you have one.
        </p>
      </section>
    </>
  );
}
